import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

const verifyAuthorUsername = (username: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.USERNAME
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.post(URL, { username }, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default verifyAuthorUsername
